import productCardSwiper from '../modules/productSwiper'

document.addEventListener('DOMContentLoaded', () => {
    document.querySelectorAll('.accordion__header').forEach((header) => {
        header.addEventListener('click', () => {
            const item = header.parentElement
            const content = header.nextElementSibling
            const isActive = item.classList.contains('accordion__content--active')
            const icon = header.querySelector('.accordion__header-icon')
            if (isActive) {
                item.classList.remove('accordion__content--active')
                content.classList.remove('accordion__content--active')
                // header.classList.remove('accordion__content--active')
                icon.classList.remove('accordion__header-icon--active')
            } else {
                item.classList.add('accordion__content--active')
                content.classList.add('accordion__content--active')
                // header.classList.add('accordion__content--active')
                icon.classList.toggle('accordion__header-icon--active')
            }
        })
    })

    async function copyToClipboard(text) {
        try {
            await navigator.clipboard.writeText(text)
            console.log('Текст скопирован: ', text)
            return true
        } catch (err) {
            console.error('Ошибка копирования: ', err)
            return false
        }
    }

    const copy = document.querySelector('.icon-share')
    const article = document.getElementById('aricle')
    if (article && copy) {
        const articleText = article.textContent
        copy.addEventListener('click', () => copyToClipboard(articleText))
    }
})
